import React from 'react';
import styled from 'styled-components';

import { Link } from '@ontruck/orc';

import Loader from 'modules/Common/Loader';
import { constants, getSpecificClientConfig } from 'redux/modules/client-config/selectors';
import { useSelector } from 'react-redux';

const StyledLink = styled(Link)`
  font-weight: 500;
  margin-left: 7px;
`;

const StyledLoader = styled(Loader)`
  margin-bottom: 0px;
`;

const t = {
  no_driver: "Send 'No driver' warning email",
  creating: 'Sending the warning email',
  error: 'Error sending the warning email',
};

const ZendeskTicketCell = ({ show, creating, handleCreateTicket, error, created }) => {
  const isZendeskEnabled = useSelector((store) =>
    getSpecificClientConfig(store, constants.ZENDESK)
  );
  if (!show || created || !isZendeskEnabled) return null;

  return (
    <>
      {creating && <StyledLoader text={t.creating} />}
      {!creating && (
        <div onClick={handleCreateTicket}>
          <StyledLink onClick={handleCreateTicket} text={error ? t.error : t.no_driver} />
        </div>
      )}
    </>
  );
};

export default ZendeskTicketCell;
